// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUpInvoice_wrapper__76Wi3","text":"TopUpInvoice_text__jHO6i"};